<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>email</mat-icon>
        <div>Cartas Anuidades</div>
      </div>
    </mat-toolbar>
  </mat-card>

  <mat-tab-group id='tabs'>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>mail_outline</mat-icon>
        Cartas
      </ng-template>

      <mat-card>
        <!-- TABLE -->
        <mat-table [dataSource]="lettersDataSource" style="height: calc(100vh - 240px); overflow:auto;">

          <!-- name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openLetterDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- delete Column -->
    
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef>
              <a mat-button (click)="openLetterDialog(null)" style='width:60px; margin-left:10px;'>
                <mat-icon color='primary'>add_circle_outline</mat-icon>
              </a>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='deleteLetter(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>
       

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedLettersColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedLettersColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

      </mat-card>


    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>people_outline</mat-icon>
        Associados
      </ng-template>

      <mat-card style="display: flex; flex-direction: row; justify-content: space-between;">

        <mat-select style="background-color: whitesmoke; padding: 10px; width: 80%"
          (ngModelChange)='selectAnnuityLetter($event)' [ngModel]='selectedAnnuityLetter'
          placeholder="Selecione uma carta">
          <mat-option *ngFor="let letter of letterArray" [value]="letter">
            {{ letter.name }}
          </mat-option>
        </mat-select>

        <div *ngIf="dataSource" flex justify-content='flex-end' fxLayoutAlign="end">
          <input class='filter' matInput (keyup)=" applyFilter($event.target.value)" placeholder='filtro'
            autocomplete="off">
        </div>

        <mat-select *ngIf="dataSource" class="filter-options" [(value)]="selectedFilter"
          (selectionChange)="applyFilterOption($event.value)">
          <mat-option *ngFor="let option of filterOptions" [value]="option.id">
            <span>{{option.label}}</span>
          </mat-option>
        </mat-select>

        <button *ngIf="dataSource" mat-raised-button (click)='reload()'>
          <mat-icon class='icon-add'>replay_circle_filled</mat-icon>
        </button>

      </mat-card>

      <mat-card>
        <!-- TABLE -->
        <mat-table [dataSource]="dataSource" matSort matSortDisableClear=false
          style="height: calc(100vh - 380px); overflow:auto;">

          <!-- name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef sticky mat-sort-header> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div style="display: flex; flex-direction: column;">
                <div>{{ element.name }}</div>
                <div><i>{{ element.subCategory_name }}</i></div>
              </div>
            </mat-cell>
          </ng-container>

          <!-- Situation Column -->
          <ng-container matColumnDef="situation">
            <mat-header-cell *matHeaderCellDef mat-sort-header sticky> Situação </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.situation }} </mat-cell>
          </ng-container>

          <!-- Credit Column -->
          <ng-container matColumnDef="credit">
            <mat-header-cell *matHeaderCellDef mat-sort-header sticky> Crédito </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.credit }} </mat-cell>
          </ng-container>

          <!-- Annuity_from Column -->
          <ng-container matColumnDef="annuity_from">
            <mat-header-cell *matHeaderCellDef mat-sort-header sticky> Desde </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.annuity_from }} </mat-cell>
          </ng-container>

          <!--Sent  Column -->
          <ng-container matColumnDef="sent">
            <mat-header-cell *matHeaderCellDef mat-sort-header sticky> Enviado </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.dateSent">
                {{ element.dateSent | date: 'dd/MM/yyyy' }}
              </span>
            </mat-cell>
          </ng-container>


          <!--Payed Column -->
          <ng-container matColumnDef="payed">
            <mat-header-cell *matHeaderCellDef mat-sort-header sticky> Pago </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.datePayed">
                {{ element.datePayed | date: 'dd/MM/yyyy' }}
              </span>
            </mat-cell>
          </ng-container>

          <!-- goto Column -->
          <ng-container matColumnDef="goto">
            <mat-header-cell *matHeaderCellDef mat-sort-header sticky> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button *ngIf="element.url" matTooltip="Acessar Link" matTooltipPosition="above" target='_blank'
                href={{element.url}} style='background-color: whitesmoke;'>
                <mat-icon class='icon-add' style='font-size:1.5em;'>search</mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element" sticky>
              <a mat-button (click)='openValuesDialog(element)' matTooltip="Visualizar extrato"
                matTooltipPosition="above" style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  format_list_bulleted
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- resend Column -->
          <ng-container matColumnDef="resend">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element" sticky>
              <a *ngIf="element.dateSent && !element.datePayed" matTooltip="Reenviar e-mail" matTooltipPosition="above"
                mat-button (click)='openResendDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-done' style='font-size:1.5em;'>
                  alternate_email
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a *ngIf="element.dateSent && !element.datePayed" mat-button matTooltip="Apagar carta"
                matTooltipPosition="above" (click)='deleteLetterSent(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="selected">
            <mat-header-cell *matHeaderCellDef sticky>
              <!--
              <mat-checkbox color='primary' #checkbox (change)='toggleCheckUsers(checkbox.checked)'>
              </mat-checkbox>
              -->
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div *ngIf="element.mustSend">
                <mat-checkbox color='primary' [(ngModel)]="element.selected">
                </mat-checkbox>
              </div>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

      </mat-card>

      <mat-card class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <button *ngIf="dataSource && canSend" mat-raised-button (click)='updateAnnuityLetters()'>
           <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
      </mat-card>

    </mat-tab>

  </mat-tab-group>




</div>